import React, { Fragment, useState, useEffect, useMemo } from "react";
import clsx from "clsx";

import styles from "./ShippingFeeList.module.scss";
import {
  HEADER_TABLE_SHIPPING_FEE,
  PACKAGE_TYPE,
} from "../../../constants/constant";
import shippingFeeApi from "../../../apis/shippingFeeApi";
import ModalShippingFee, {
  convertPartnerPackageTypesConfigId,
} from "../Modal/Modal";
import PROVINCE from "../../../constants/province";
import DISTRICT from "../../../constants/district";
import WARD from "../../../constants/ward";
import Loading from "../../Loading";
import { useSnackbar } from "notistack";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import donationApi from "../../../apis/donationApi";
import { typeZeroWaste } from "../../../constants/constant";
import { useNavigate } from "react-router-dom";
import StorageService from "../../../services/StorageService";

export interface ShippingFeeListProps {
  className?: string;
  dataSubmit: any;
  setDataSubmit: any;
}

const ShippingFeeList = (props: ShippingFeeListProps) => {
  const { className, dataSubmit } = props;
  const [shippingFee, setShippingFee] = useState<any>([]);
  const [dataSubmitEdit, setDataSubmitEdit] = useState<any>([]);
  const [zeroWasteList, setZeroWasteList] = useState<any[]>([]);
  useEffect(() => {
    (async () => {
      try {
        const payload = { filter: { ids: [], packageTypeId: "", partnerId: "" }, paging: { limit: 0, offset: 0 } };
        const res = await donationApi.searchZeroWaste(payload);
        if (res.data.code === 0) setZeroWasteList(res.data.data.data);
      } catch (error) {}
    })();
  }, []);
  const [loading, setLoading] = useState<boolean>(false);
  const [idItemEdit, setIdItemEdit] = useState<any>("");

  const navigate = useNavigate();

  const [urbanFee, setUrbanFee] = useState<any>("");

  const [idRemove, setIdRemove] = useState<any>("");

  const [packgeType, setPackgeType] = useState<any>("");
  const [provinceCode, setProvinceCode] = useState<any>("");
  const [districtCode, setDistrictCode] = useState<any>("");
  const [wardCode, setWardCode] = useState<any>("");

  // Filter states
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState<string>("all");
  const [searchKeyword, setSearchKeyword] = useState<string>("");


  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { enqueueSnackbar } = useSnackbar();

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [idToDelete, setIdToDelete] = useState<number | null>(null);

  const handleOpenDeleteConfirm = (id: number) => {
    setIdToDelete(id);
    setOpenDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
    setIdToDelete(null);
  };

  const removeShippingFee = async () => {
    if (idToDelete === null) return;
    try {
      const res = await shippingFeeApi.deleteShippingFee({
        id: idToDelete,
      });
      const dataRES = res?.data?.data;

      if (dataRES) {
        setIdRemove(idToDelete);
        enqueueSnackbar("Xoá thành công", { variant: "success" });
      } else {
        enqueueSnackbar(res.data.message, { variant: "error" });
      }
      handleCloseDeleteConfirm();
    } catch (error) {
      console.log(error);
      handleCloseDeleteConfirm();
    }
  };
  const rawWarehouseData = localStorage.getItem("warehouseData");
  const warehouseData = (rawWarehouseData && rawWarehouseData !== "undefined") ? JSON.parse(rawWarehouseData) : {};

  // Get partnerId from JWT token (avoid stale localStorage partnerData)
  const getPartnerIdFromToken = (): string => {
    return process.env.REACT_APP_ENV === "production" ? "01G486CQAV7VW2FK3DHZV1T2FG" : "01G4866BBJGYR1JH8E6RPYEW2C";
  };

  const [allConfigs, setAllConfigs] = useState<any[]>([]);

  useEffect(() => {
    const getShippingFee = async () => {
      setLoading(true);
      try {
        let configs: any[] = [];
        let offset = 0;
        const limit = 100;
        let hasMore = true;

        while (hasMore) {
          const res = await shippingFeeApi.getShippingFee({
            filter: {
              partnerId: getPartnerIdFromToken(),
              partnerWareHouseId: warehouseData?.id,
            },
            paging: {
              limit,
              offset,
            },
          });

          if (res?.data?.message === "Unauthenticated") {
            localStorage.clear();
            navigate("/login");
            return;
          }

          const pageConfigs = res?.data?.data?.shippingFeeConfig || [];
          configs = [...configs, ...pageConfigs];

          if (pageConfigs.length < limit || !res?.data?.data?.nextPage) {
            hasMore = false;
          } else {
            offset += limit;
          }
        }

        // Deduplicate configs by id to avoid duplicated keys from pagination
        const uniqueConfigs: any[] = [];
        const seenIds = new Set<string>();
        for (const cfg of configs) {
          if (cfg?.id && !seenIds.has(cfg.id)) {
            seenIds.add(cfg.id);
            uniqueConfigs.push(cfg);
          } else if (!cfg?.id) {
            uniqueConfigs.push(cfg);
          }
        }

        setAllConfigs(uniqueConfigs);

        const result = uniqueConfigs.reduce((acc: any, cur: any) => {
          const provId = cur.provinceId || cur.province_id || "202";
          const found = acc.find(
            (item: any) => item.provinceId === provId
          );
          const shipItem = {
            id: cur.id,
            packageType: cur.partnerPackageTypesConfigId || cur.package_type || cur.packageType,
            shipping_fee: cur.price !== undefined ? cur.price : (cur.urban_fee || cur.urbanFee || 0),
            districtId: cur.districtId || cur.district_id || "",
            wardId: cur.wardId || cur.ward_id || "",
            provinceId: provId,
          };

          if (found) {
            found.shipping_fee.push(shipItem);
          } else {
            acc.push({
              provinceId: provId,
              shipping_fee: [shipItem],
            });
          }
          return acc;
        }, []);

        result?.forEach((item: any) => {
          item.shipping_fee.sort((a: any, b: any) => {
            return (
              convertPartnerPackageTypesConfigId.findIndex(
                (item) => item.to === a.packageType
              ) -
              convertPartnerPackageTypesConfigId.findIndex(
                (item) => item.to === b.packageType
              )
            );
          });
        });

        setShippingFee(result || []);
      } catch (error) {
        console.error("[ShippingFeeList] getShippingFee error:", error);
      } finally {
        setLoading(false);
      }
    };

    const tokenHYDRAInLocal = StorageService.token || localStorage.getItem("tokenHYDRA");
    if (tokenHYDRAInLocal) {
      getShippingFee();
    }
  }, [
    dataSubmit,
    enqueueSnackbar,
    open,
    dataSubmitEdit,
    idRemove,
    navigate,
    warehouseData?.id,
  ]);

  const editShippingFee = async (data: any) => {
    try {
      const res = await shippingFeeApi.updateShippingFee({
        ...data,
        id: idItemEdit,
      });

      const dataRES = res?.data?.data;

      if (dataRES) {
        enqueueSnackbar("Chỉnh sửa thành công", { variant: "success" });
        setDataSubmitEdit(dataRES);
        setPackgeType("");
        setProvinceCode("");
        setUrbanFee("");
        handleClose();
      } else {
        enqueueSnackbar(res.data.message, { variant: "error" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (dataItem: any) => {
    setProvinceCode(dataItem.provinceId);
    setDistrictCode(dataItem.shipping_fee.districtId || "");
    setWardCode(dataItem.shipping_fee.wardId || "");
    setPackgeType(dataItem.shipping_fee.packageType);
    setUrbanFee(dataItem.shipping_fee.shipping_fee);
    setIdItemEdit(dataItem.shipping_fee.id);
    handleOpen();
  };

  const parsePackageType = (type: string) => {
    const foundInZeroWaste = zeroWasteList.find((item: any) => item.partnerPackageTypesConfigId === type);
    if (foundInZeroWaste) return typeZeroWaste(type) || foundInZeroWaste.packageTypeName || type;
    const result = convertPartnerPackageTypesConfigId.find((item) => item.to === type);
    const result2 = PACKAGE_TYPE.find((item) => item.packageType === result?.from);
    return result2?.label || type;
  };

  const parseCodeToProvince = (code: string) => {
    const result = PROVINCE.find((item) => item.code === code);
    return result?.label;
  };

  const parseCodeToDistrict = (code: string) => {
    if (!code) return "";
    const result = DISTRICT.find((item: any) => item.code === code);
    return result?.name || code;
  };

  const parseCodeToWard = (code: string) => {
    if (!code) return "";
    const result = WARD.find((item: any) => item.code === code);
    return result?.name || code;
  };

  // Extract unique districts present in currently loaded shipping fees for the dropdown
  const availableDistricts = useMemo(() => {
    const map = new Map<string, { code: string; name: string }>();
    shippingFee.forEach((item: any) => {
      item?.shipping_fee?.forEach((ship: any) => {
        if (ship.districtId) {
          const rawId = String(ship.districtId).trim();
          const name = parseCodeToDistrict(rawId) || rawId;
          // Use name as unique key so code "1449" and name "Quận 7" don't become duplicates
          if (!map.has(name)) {
            map.set(name, { code: rawId, name });
          }
        }
      });
    });
    return Array.from(map.values())
      .sort((a, b) => a.name.localeCompare(b.name, "vi", { numeric: true, sensitivity: "base" }));
  }, [shippingFee]);

  // Filter shipping fee records by selected district or search keyword
  const filteredShippingFee = useMemo(() => {
    if (selectedDistrictFilter === "all" && !searchKeyword.trim()) {
      return shippingFee;
    }

    const kw = searchKeyword.trim().toLowerCase();

    return shippingFee
      .map((item: any) => {
        const matchedFees = (item.shipping_fee || []).filter((ship: any) => {
          const districtName = (parseCodeToDistrict(ship.districtId) || "").toLowerCase();
          const wardName = (parseCodeToWard(ship.wardId) || "").toLowerCase();
          const districtCode = (ship.districtId || "").toString().toLowerCase();

          // District filter: check both code and resolved name
          if (selectedDistrictFilter !== "all") {
            const filterTarget = selectedDistrictFilter.toLowerCase();
            const filterTargetName = (parseCodeToDistrict(selectedDistrictFilter) || selectedDistrictFilter).toLowerCase();
            const isMatch =
              districtCode === filterTarget ||
              districtName === filterTarget ||
              districtName === filterTargetName ||
              districtCode === filterTargetName;

            if (!isMatch) {
              return false;
            }
          }

          // Search keyword filter
          if (kw) {
            const matchesDistrict = districtName.includes(kw) || districtCode.includes(kw);
            const matchesWard = wardName.includes(kw);
            const matchesPackage = (parsePackageType(ship.packageType) || "").toLowerCase().includes(kw);
            if (!matchesDistrict && !matchesWard && !matchesPackage) {
              return false;
            }
          }

          return true;
        });

        if (matchedFees.length === 0) return null;

        return {
          ...item,
          shipping_fee: matchedFees,
        };
      })
      .filter(Boolean);
  }, [shippingFee, selectedDistrictFilter, searchKeyword]);

  const totalFilteredRecords = useMemo(() => {
    return filteredShippingFee.reduce((sum: number, item: any) => sum + (item?.shipping_fee?.length || 0), 0);
  }, [filteredShippingFee]);

  return (
    <div className={clsx(styles.root, className && className)}>
      {/* Filter by district and search */}
      <div className={styles.filterContainer}>
        <div className={styles.filterLabel}>
          <span>🔍 Lọc theo quận/huyện:</span>
        </div>

        <select
          className={styles.selectDistrict}
          value={selectedDistrictFilter}
          onChange={(e) => setSelectedDistrictFilter(e.target.value)}
        >
          <option value="all">-- Tất cả quận/huyện ({availableDistricts.length}) --</option>
          {availableDistricts.map((d) => (
            <option key={d.code} value={d.code}>
              {d.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          className={styles.searchInput}
          placeholder="Tìm tên quận, phường, trọng lượng..."
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
        />

        {(selectedDistrictFilter !== "all" || searchKeyword.trim()) && (
          <button
            type="button"
            className={styles.clearFilterBtn}
            onClick={() => {
              setSelectedDistrictFilter("all");
              setSearchKeyword("");
            }}
          >
            ✕ Bỏ lọc
          </button>
        )}

        <div className={styles.filterCount}>
          Hiển thị: <b>{totalFilteredRecords}</b> mức giá
        </div>
      </div>

      <div className={styles.orderListWrap}>
        <div className={styles.orderList}>
          <table className={styles.orderListTable}>
            <thead>
              <tr>
                {HEADER_TABLE_SHIPPING_FEE.map((item) => {
                  return <th key={item.id}>{item.title}</th>;
                })}
              </tr>
            </thead>
            <tbody>
              <Fragment>
                {filteredShippingFee?.length > 0 ? (
                  filteredShippingFee
                    ?.sort((a: any, b: any) => {
                      if (a.provinceId < b.provinceId) {
                        return -1;
                      }
                      if (a.provinceId > b.provinceId) {
                        return 1;
                      }
                      return 0;
                    })
                    ?.map((item: any, itemIndex: number) => {
                      const sortedFees = [...(item?.shipping_fee || [])].sort((a: any, b: any) => {
                        const distA = parseCodeToDistrict(a.districtId) || "";
                        const distB = parseCodeToDistrict(b.districtId) || "";
                        const distCompare = distA.localeCompare(distB, "vi", { numeric: true, sensitivity: "base" });
                        if (distCompare !== 0) return distCompare;

                        const pkgA = parsePackageType(a.packageType) || "";
                        const pkgB = parsePackageType(b.packageType) || "";
                        return pkgA.localeCompare(pkgB, "vi", { numeric: true });
                      });

                      return (
                        <Fragment key={`province-${item.provinceId || itemIndex}`}>
                          {sortedFees.map((shipType: any, index: number) => {
                            const isFirst = index === 0;

                            return (
                              <tr className={clsx(styles.item)} key={`${shipType.id || "item"}-${index}`}>
                                {isFirst && (
                                  <>
                                    <td rowSpan={sortedFees.length}>
                                      {item.provinceId}
                                    </td>
                                    <td rowSpan={sortedFees.length}>
                                      {parseCodeToProvince(item.provinceId) || item.provinceId}
                                    </td>
                                  </>
                                )}
                                <td>
                                  {parseCodeToDistrict(shipType.districtId)}
                                </td>
                                <td>
                                  {parseCodeToWard(shipType.wardId)}
                                </td>

                                <td>
                                  {parsePackageType(shipType.packageType)}
                                </td>

                                  <td>
                                    {shipType.shipping_fee?.toLocaleString()}
                                  </td>

                                  <td className={styles.tdAction}>
                                    <div
                                      className={styles.finished}
                                      onClick={() =>
                                        handleEdit({
                                          provinceId: item.provinceId,
                                          shipping_fee: shipType,
                                        })
                                      }
                                    >
                                      Chỉnh sửa
                                    </div>
                                    <div
                                      className={styles.canceled}
                                      onClick={() =>
                                        handleOpenDeleteConfirm(shipType.id)
                                      }
                                    >
                                      Xoá
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                        </Fragment>
                      );
                    })
                ) : loading ? (
                  <tr>
                    <td className={styles.noneData} colSpan={7}>
                      <div className={styles.loadingWrap}>
                        <Loading />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td className={styles.noneData} colSpan={7}>
                      Không có dữ liệu
                    </td>
                  </tr>
                )}
              </Fragment>
            </tbody>
          </table>
        </div>
      </div>

      <ModalShippingFee
        open={open}
        handleClose={handleClose}
        isEdit={true}
        setDataSubmit={setDataSubmitEdit}
        handleSubmitModal={editShippingFee}
        packgeType={packgeType}
        setPackgeType={setPackgeType}
        provinceCode={provinceCode}
        setProvinceCode={setProvinceCode}
        districtCode={districtCode}
        setDistrictCode={setDistrictCode}
        wardCode={wardCode}
        setWardCode={setWardCode}
        urbanFee={urbanFee}
        setUrbanFee={setUrbanFee}
        parsePackageType={parsePackageType}
      />

      <Dialog
        open={openDeleteConfirm}
        onClose={handleCloseDeleteConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Xác nhận xóa"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bạn có chắc chắn muốn xóa phí vận chuyển này không? Hành động này không thể hoàn tác.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirm}>Hủy</Button>
          <Button onClick={removeShippingFee} autoFocus color="error">
            Xóa
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ShippingFeeList;

